export const getUploadDocumentsModalStyles = (
  theme,
  { isModal, isDragEnter, customStyles = {} } = {},
) => ({
  formWrapper: {
    maxWidth: isModal ? '600px' : '500px',
    overflow: 'hidden',
    ...customStyles.formWrapper,
  },
  cardsWrapper: {
    overflow: 'auto',
    maxHeight: 220,
  },
  fileInput: {
    '&:focus + label': {
      border: `2px solid ${theme.palette.secondary.main}`,
    },
  },
  label: {
    position: 'relative',
    minHeight: 160,
    padding: '16px 16px 100px',
    marginBottom: '24px',
    border: isDragEnter
      ? `2px solid ${theme.palette.secondary.main}`
      : `2px dashed ${theme.palette.divider}`,
    borderRadius: 4,
    '& > div': {
      pointerEvents: isDragEnter ? 'none' : 'auto',
    },
  },
  fileCard: {
    display: 'flex',
    alignItems: 'center',
    height: 60,
    backgroundColor: theme.palette.primary.main,
  },
  removeFileButton: {
    '& > *': {
      pointerEvents: 'none',
    },
  },
  dndTip: {
    position: 'absolute',
    bottom: 16,
    left: '50%',
    width: 300,
    transform: 'translateX(-50%)',
    color: isDragEnter ? `${theme.palette.secondary.main}` : '',
  },
  browseHint: {
    color: theme.palette.text.secondary,
    mt: '4px',
  },
  browseLink: {
    color: theme.palette.primary.main,
    fontWeight: 700,
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  errorText: {
    color: theme.palette.error.main,
  },
  successIcon: {
    color: theme.palette.success.main,
  },
  buttonsContainer: {
    '& > :not(:last-child)': {
      marginRight: '8px',
    },
    ...customStyles.buttonsContainer,
  },
});
